import { fetchData, API_TYPE, IResponse } from '@umu/umu-fetch';
import { IPracticeInviteUserData, IPracticeInviteScoreParams, IPracticeInviteUserParams } from '../types';

const API = {
    savePractice: {
        url: '/uapi/v1/homework/save',
        type: API_TYPE.GET,
    },
    practiceList: {
        url: '/uapi/v1/channel/my-practice',
        type: API_TYPE.GET,
    },
    practiceChart: {
        url: '/uapi/v1/channel/my-practice-chart',
        type: API_TYPE.GET,
    },
    practiceStatistics: {
        url: '/uapi/v1/channel/my-statistics',
        type: API_TYPE.GET,
    },
    // practice-invite-user
    practiceInviteUser: {
        url: '/uapi/v1/channel/practice-invite-user',
        type: API_TYPE.GET,
    },
    // practice-invite-score
    practiceInviteScore: {
        url: '/uapi/v1/channel/practice-invite-score',
        type: API_TYPE.GET,
    },
};

// practice-invite-score
const fetchPracticeInviteScore = async (params: IPracticeInviteScoreParams): Promise<{ status: number }> => {
    return fetchData(API.practiceInviteScore, params).then((res: IResponse<{ status: number }>) => {
        return res.data;
    });
};

// practice-invite-user
const fetchPracticeInviteUser = async (params: IPracticeInviteUserParams): Promise<IPracticeInviteUserData> => {
    return fetchData(API.practiceInviteUser, params).then((res: IResponse<IPracticeInviteUserData>) => {
        return res.data;
    });
};

export { API, fetchPracticeInviteScore, fetchPracticeInviteUser };
